<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-07 15:01:24
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-05-21 09:56:39
-->
<template>
	<div class="DeliveryCell">
		<rdShopInfo
			class="font-h6-medium"
			:shopInfo="{ name: row['anchor_name'] }"
			:showShopIcon="true"
			:platformId="row.platform_id"
			:textWidth="100"
		></rdShopInfo>
		<div>
			{{ row.platform_id | formatPlatformName('unify') }}：{{ row['anchor_account'] | formatEmpty }}
			<span class="hint ml-8" v-if="($isSp(row.platform_id) && !row['anchor_account']) || row['anchor_account'] === '--'" @click="injectSetSpid(row)">
				<i class="el-icon-warning mt-2 fz-14"></i>
				<span class="fz-12 ml-4">填写视频号ID</span>
				<i class="el-icon-arrow-right"></i>
			</span>
		</div>

		<div>
			<span :class="['role', row['colonel_type'] === '1' ? 'head' : 'talent']">{{ row['colonel_type_desc'] }}</span>
		</div>
		<div v-if="$isSp(row.platform_id) && row.colonel_type == 2" class="text-ellipsis">
			<div>团长名称：{{ row['sub_nick_name'] | formatEmpty }}</div>
			<div>团长ID：{{ row['sub_appid'] | formatEmpty }}</div>
		</div>
	</div>
</template>
<script>
import mixin from './mixin';

export default {
	mixins: [mixin],
	inject: {
		injectSetSpid: {
			default: () => () => {},
		},
	},
};
</script>
<style lang="less" scoped>
.role {
	font-size: 12px;
	border-radius: 2px;
	padding: 2px 4px;
}
.talent {
	background: #ffeeed;
	color: #fa2714;
}
.head {
	background: #e9f1ff;
	color: @color-primary;
}
.hint {
	/* CN-Regular/12 */
	font-family: PingFang SC;
	font-size: 12px;
	font-weight: normal;
	line-height: 20px;
	letter-spacing: 0em;

	/* warning/warning6 */
	color: #f97a00;
	&:hover {
		cursor: pointer;
	}
}
</style>
